<template>
  <div>
       <TableBlock ref="tableData" :columns="columns" :action="action" :showBtn="false" :ispage="true" :autRequest="true"  :param="param" :navHeight="260"  @checkVal="getCheckVal">
        <div class="common-items-center common-space-between">
          <div class="common-items-center">
            <InputBlock title="产品名称">
              <el-input v-model="param.name" :size="this.$store.state.inputSize" placeholder="请输入产品名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
            </InputBlock>
            <InputBlock title="企业名称">
              <el-input v-model="param.factoryName" :size="this.$store.state.inputSize" placeholder="请输入企业名称" onkeyup='value=value.replace(/^\s*|\s*$/g,"")'/>
            </InputBlock>
            <div>
              <Eqcl ref="deviceType" @getVal="getVal"/>
            </div>
            <el-button :size="this.$store.state.btnSize" type="primary" icon="el-icon-search" @click="serachBtn">查询</el-button>
            <el-button :size="this.$store.state.btnSize" type="danger"  icon="el-icon-refresh-left" @click="resetBtn">重置</el-button>
          </div>
          <div>
            <!-- <el-button :size="this.$store.state.btnSize" type="primary" icon="el-icon-download"   @click="exportBtn">导出</el-button> -->
          </div>
        </div>
       </TableBlock>
       <LookBlock ref="lookBlock"></LookBlock> 
  </div>
</template>
<script>
import {columns} from './columns/columns-message';
import {userApi,operate,url,api} from '@/utils/config'
import {postFun,deleteFun,getFun} from '@/utils/httpFun'
import LookBlock from './message/block-info.vue'
import Eqcl from './message/block-eqClass.vue'
export default {
  name: 'index',
  components:{
    LookBlock,
    Eqcl
  },
  data:()=>({  
    columns:[],
    action:operate.PRODUCTLIST,
    param:{
      name:null,
      factoryName:null,
      deviceType:"",
    }
  }),
  created(){
    this.columns = columns(this);
  },
  methods:{

    //获取下拉框的值设备分类
    getVal(ev){
       this.param.deviceType = ev.id
    },

    //查询
    serachBtn(){
      this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
    },

    //重置
    resetBtn(){
       this.param.name = null
       this.param.factoryName = null
       this.param.deviceType = null
       this.$refs.deviceType.setVl(null)
       this.$nextTick(res=>{
           this.$refs.tableData.resetHttp() 
       })
    },

    //查看产品名称的详情
     openProduct(ev){
        getFun(operate.PRODUCTDETAIL+"/"+ev.id+"",{},res=>{
          let data = res.data
          let parms = {
              imgList:res.data.resources,
              list:[
                {title:"产品名称",val:data.name},
                {title:"产品分类",val:data.deviceTypeName},
                {title:"设备分类",val:data.typeName},
                {title:"产品型号",val:data.model},
                {title:"企业名称",val:data.factoryName},
                {title:"协议名称",val:data.protocolName},
                {title:"更新时间",val:!data.updateTime ? data.createTime : data.updateTime},
                {title:"协议公司",val:data.factoryName},
                {title:"最近操作人",val:data.operator},
                {title:"版本",val:data.protocolVersion},
                {title:"备注",val:data.describes}
              ]
            }
            this.$refs.lookBlock.openBtn(parms)
        })
     }, 

     //查看企业
     openCompany(ev){
        this.$router.replace({
           path:"EnMessage",
           query:{
              factoryId:ev.factoryId
           }
        })
     },

    //导出
    exportBtn(){

    },
    
    //复选框的值
    getCheckVal(){

    }

  }
}
</script>
<style lang="scss" scoped>
    .container{
        padding:15px;
        box-sizing: border-box;
    }
    .warp-table{
        margin-top: 15px;
        width: 100%;
    }
    .titleText{
       font-size: 14px;
       color: #606266;
    }
    .inputBlock{
       margin-right:20px;
       width: 140px;
    }
    .lookName{
        color: #458EFF;
        cursor: pointer;
    }
</style>
